import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { checkoutUrl } from '../data/offer';
import { handleCheckoutClick } from './CtaButton';

/** Fixed checkout bar for phones, revealed once the hero is out of view. */
export function MobileCheckoutBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-134" data-mp="ixrslvhqgtbs">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-surface/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden" data-id="element-135" data-mp="iwzy6nzvh1n3">
          <div className="flex items-center gap-3" data-id="element-136" data-mp="336xdqtrqp7ow">
            <div className="shrink-0" data-id="element-137" data-mp="2y72pyz39gy82">
              <p className="flex items-baseline gap-1.5" data-id="element-138" data-mp="2y84bjxhwl341">
                <span className="font-display text-2xl font-semibold leading-none text-ink" data-id="element-139" data-mp="3d4bvcwpeg2is">
                  $27
                </span>
                <span className="text-xs font-medium text-ink-muted line-through" data-id="element-140" data-mp="3847a6tdjqjm8">$745</span>
              </p>
              <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-rust" data-id="element-141" data-mp="3m3p4fo9m2p2z">
                Ends tonight
              </p>
            </div>
            <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick('mobile_sticky_bar')} className="flex flex-1 items-center justify-center rounded-full bg-rust px-4 py-3.5 text-xs font-semibold uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-expo active:bg-rust-dark" data-id="element-142" data-mp="3vvcsdf6ylnzp">
              Get the bundle
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}